export default "__VITE_ASSET__OeSL4mE5__"